import { HTMLMotionProps, motion } from 'framer-motion';

export interface MorphingSquareProps {
    message?: string;
    messagePlacement?: "top" | "bottom" | "left" | "right";
}

const getFlexDirection = (placement: string) => {
    switch (placement) {
        case 'top': return 'flex-col-reverse';
        case 'bottom': return 'flex-col';
        case 'right': return 'flex-row';
        case 'left': return 'flex-row-reverse';
        default: return 'flex-col';
    }
};

export function MorphingSquare({
    className = '',
    message,
    messagePlacement = "bottom",
    ...props
}: HTMLMotionProps<"div"> & MorphingSquareProps) {
    const flexDirection = getFlexDirection(messagePlacement);

    return (
        <div className={`flex gap-2 items-center justify-center ${flexDirection}`}>
            <motion.div
                className={`w-10 h-10 bg-white ${className}`}
                animate={{
                    borderRadius: ["6%", "50%", "6%"],
                    rotate: [0, 180, 360],
                }}
                transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
                {...props}
            />
            {message && <div className="text-white">{message}</div>}
        </div>
    );
}
